module.exports = __webpack_public_path__ + "static/media/Capture.560c3815.JPG";